import { IComputeMathFunction } from './IComputeMathFunction';

export const ComputeMathLogicFunctions: IComputeMathFunction[] = [
  /**
   * Default di un valore nullo
   * Da verificare con il `conserNullsAsZero`
   */
  // {
  //   name: 'nullo',
  //   description:
  //     'Restituisce il primo elemento se non è nullo, altrimenti il secondo. Ad esempio: `nullo(1, 2)` restituisce 1, `nullo(null, 2)` restituisce 2.',
  //   arguments: [{ type: 'number' }, { type: 'number' }],
  //   returnType: 'number',
  //   fn: MathJs =>
  //     MathJs.typed('nullo', {
  //       [`number, number`]: function (a: unknown, b: unknown) {
  //         console.log(`a, b`, a, b);
  //         return a == null ? b : a;
  //       }
  //     })
  // }
];
